<div class="w-100" style="padding: 0 0 10px 0;" *ngIf="shouldShowPagination()">
  <div [class]="containerClass" [style.border-top]="'1px solid #dee2e6'" style="background-color: #fff; padding-top: 8px;">
    <div class="row align-items-center">
      <div class="col-md-6" *ngIf="showRecordsInfo">
        <span class="d-flex align-items-center text-secondary">
          <i class="fas fa-info-circle mr-2 text-info"></i>
          <strong class="text-dark">{{getStartRecord()}}</strong>
          <span class="mx-1">-</span>
          <strong class="text-dark">{{getEndRecord()}}</strong>
          <span class="mx-1">de</span>
          <strong class="text-dark">{{pageInfo.count_records}}</strong>
          <span class="ml-1">registros</span>
        </span>
      </div>
      <div [class]="showRecordsInfo ? 'col-md-6' : 'col-md-12'">
        <div class="d-flex justify-content-end align-items-center">
          <!-- Input Group Compacto para Paginación -->
          <div class="input-group input-group-sm" style="width: 220px;">
            <div class="input-group-prepend">
              <button class="btn btn-outline-secondary" 
                      type="button" 
                      [disabled]="pageInfo.page_number == 1"
                      (click)="onChangePage('-')"
                      title="Página anterior">
                <i class="fas fa-chevron-left"></i>
              </button>
            </div>
            <div class="input-group-prepend">
              <span class="input-group-text text-secondary small" style="background-color: white; font-weight: 500;">
                Pág.
              </span>
            </div>
            
            <!-- Label clickeable cuando no está en edición -->
            <div *ngIf="!isPageInputEditing" 
                 class="form-control d-flex align-items-center justify-content-center cursor-pointer position-relative" 
                 style="max-width: 80px; font-size: 13px; background-color: white;
                        transition: all 0.2s ease; min-height: 31px; box-shadow: none;"
                 (click)="activatePageInputEditing()"
                 (mouseenter)="$event.target.style.backgroundColor = '#f8f9fa'"
                 (mouseleave)="$event.target.style.backgroundColor = 'white'"
                 title="Click para editar página">
              <strong style="font-weight: 600;">{{pageInfo.page_number}}</strong>
              <i class="fas fa-edit position-absolute" 
                 style="font-size: 8px; top: 2px; right: 3px; opacity: 0.6; color: #6c757d;"></i>
            </div>
            
            <!-- Input cuando está en modo edición -->
            <input *ngIf="isPageInputEditing"
                   type="number" 
                   class="form-control text-center page-input-field" 
                   style="max-width: 80px; font-size: 13px;
                          box-shadow: inset 0 1px 2px rgba(0,0,0,0.1), 0 0 0 2px rgba(0,123,255,0.25); 
                          background-color: white; transition: all 0.2s ease; min-height: 31px;" 
                   [value]="pageInfo.page_number"
                   min="1" 
                   [max]="pageInfo.total_pages"
                   (change)="onPageInputChange($event)"
                   (keydown)="onPageInputKeyPress($event)"
                   (blur)="onPageInputBlur($event)"
                   title="Presiona Enter para confirmar o Escape para cancelar">

            <div class="input-group-append">
              <span class="input-group-text text-secondary small" style="background-color: white; font-weight: 500;">
                de {{pageInfo.total_pages}}
              </span>
            </div>
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" 
                      type="button" 
                      [disabled]="pageInfo.page_number == pageInfo.total_pages"
                      (click)="onChangePage('+')"
                      title="Página siguiente">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
